import React, { useEffect, useState } from "react";
import { Table, Tag, Button, Row } from "antd";
import { useLoading } from "../../context/loadingContext";
import dayjs from "dayjs";
import GetMerchantVatOut from "../../functions/merchant/getMerchantVatOut";
import moneyFormat from "../../functions/utils/moneyFormat";
import { EyeFilled, RedoOutlined } from "@ant-design/icons";
import MerchantVatOutDetail from "../../components/modal/merchantVatOutDetail";
import { useMerchant } from "../../context/merchantContext";
import SearchDatePickerIncome from "../../components/search/datePickerIncome";
import TablePagination from "components/pagination/tablePagination";
import { bg_button, bg_shadow, bg_text } from "constant/css";
import { getMerchantId } from "service/storage";

const MerchantVatOut = () => {
  const { showLoading, hideLoading } = useLoading();
  const { searchFieldsIncome } = useMerchant();
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [paginationData, setPaginationData] = useState({});
  const [showDetail, setShowDetail] = useState(null);
  const [totals, setTotals] = useState({
    totalMerchantFee: 0,
    totalVatAmount: 0,
  });

  useEffect(() => {
    prepareQueryStringAndSearch();
    // eslint-disable-next-line
  }, [searchFieldsIncome, page, pageSize]);

  useEffect(() => {
    refresh();
    // eslint-disable-next-line
  }, []);

  const prepareQueryStringAndSearch = () => {
    const searchFieldsLength = Object.keys(searchFieldsIncome).length;
    let queryString = "";
    if (searchFieldsLength !== 0) {
      queryString = Object.keys(searchFieldsIncome)
        .map((key) => {
          if (!searchFieldsIncome[key]) return "";
          if (key.includes("At")) {
            return `${key}=${searchFieldsIncome[key]
              .map((e, i) => {
                if (i === 0)
                  return dayjs(e).startOf("day").format("YYYY-MM-DD HH:MM");
                return dayjs(e).endOf("day").format("YYYY-MM-DD HH:MM");
              })
              .join("->")}`;
          }
          return `${key}=${encodeURIComponent(searchFieldsIncome[key])}`;
        })
        .join("&");
      fetchData(queryString, page, pageSize);
    }
  };

  const columns = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      fixed: "left",
      width: 20,
      className: "text-xs",
    },
    {
      title: "Нийт дүн",
      dataIndex: "amount",
      key: "amount",
      width: 50,
      render: (e) => <span className="text-xs">{moneyFormat(e)}₮</span>,
      className: "text-xs",
      align: "right",
    },
    {
      title: "Tоо/ш",
      dataIndex: "count",
      key: "count",
      width: 50,
      render: (e) => <span className="text-xs">{e}</span>,
      className: "text-xs",
      align: "right",
    },
    {
      title: "Мерчант шимтгэл",
      dataIndex: "merchantAmount",
      key: "merchantAmount",
      width: 50,
      render: (e) => <span className="text-xs">{moneyFormat(e)}₮</span>,
      className: "text-xs",
      align: "right",
    },
    {
      title: "НӨАТ дүн",
      dataIndex: "totalVatAmount",
      key: "totalVatAmount",
      width: 50,
      render: (e) => (
        <span className="text-xs text-orange-700">{moneyFormat(e)}₮</span>
      ),
      className: "text-xs",
      align: "right",
    },
    {
      title: "Дэд мерчант",
      dataIndex: "vatSubMerchantCount",
      key: "vatSubMerchantCount",
      width: 50,
      render: (e) => <span className="text-xs">{e || 0}</span>,
      className: "text-xs",
      align: "right",
    },
    {
      title: (
        <SearchDatePickerIncome
          title="Үүссэн огноо"
          datePicker
          fieldName="createdAt"
        />
      ),
      dataIndex: "createdAt",
      key: "createdAt",
      width: 100,
      render: (e) => (
        <span className="text-xs">
          {e ? dayjs(e).format("YYYY-MM-DD") : "-"}
        </span>
      ),
      className: "text-xs",
      align: "center",
    },
    {
      title: "Төлөв",
      dataIndex: "status",
      key: "status",
      width: 50,
      render: (e) =>
        e === "SETTLED" ? (
          <Tag color="cyan" className="text-xs px-1 py-0.5">
            Өндөрлөсөн
          </Tag>
        ) : e === "ACTIVE" ? (
          <Tag color="blue" className="text-xs px-1 py-0.5">
            Идэвхтэй
          </Tag>
        ) : (
          <Tag color="default" className="text-xs px-1 py-0.5">
            Идэвхгүй
          </Tag>
        ),
      className: "text-xs",
    },
    {
      title: "",
      dataIndex: "action",
      key: "action",
      fixed: "right",
      width: 30,
      render: (_, r) => (
        <Button
          size="small"
          onClick={() => setShowDetail(r.id)}
          icon={<EyeFilled style={{ color: "green", fontSize: 14 }} />}
          className="p-0 h-6 w-6 flex items-center justify-center"
        />
      ),
      className: "text-xs",
    },
  ];

  const fetchData = async (queryString, page, size) => {
    showLoading();
    const merchantId = getMerchantId();
    const response = await GetMerchantVatOut(
      merchantId,
      `&page=${page}&size=${size}&${queryString}`
    );
    hideLoading();
    if (response) {
      setData(response.data);
      setPaginationData(response.pagination);
      setTotals({
        totalMerchantFee: response.totalMerchantFee || 0,
        totalVatAmount: response.totalVatAmount || 0,
      });
    }
  };

  const changePage = (page) => {
    setPage(page);
    fetchData("", page, pageSize);
  };

  const changeSize = (current, size) => {
    setPageSize(size);
    fetchData("", current, size);
  };

  const refresh = () => {
    setPage(1);
    fetchData("", 1, pageSize);
  };

  return (
    <div className="vatMerchantListontainer p-2 md:p-4">
      <Row className="mb-2 gap-2">
        <div>
          <Button
            type="primary"
            className={`${bg_button} rounded-xl ${bg_shadow}`}
            size="medium"
            onClick={refresh}
            icon={<RedoOutlined />}
          />
        </div>
      </Row>
      <div className="tableContainer">
        <Table
          columns={columns}
          rowKey={(record) => record.id}
          scroll={{
            x: "max-content",
            y: "calc(100vh - 48vh)",
          }}
          pagination={false}
          dataSource={data}
          size="small"
          className="text-xs"
          summary={() => (
            <Table.Summary fixed>
              <Table.Summary.Row>
                <Table.Summary.Cell index={0} />
                <Table.Summary.Cell index={1} />
                <Table.Summary.Cell index={2} />
                <Table.Summary.Cell index={3} align="right">
                  <span className={`font-semibold ${bg_text}`}>
                    {moneyFormat(totals.totalMerchantFee)}
                  </span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={4} align="right">
                  <span className="font-semibold text-orange-700">
                    {moneyFormat(totals.totalVatAmount)}
                  </span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={5} />
                <Table.Summary.Cell index={6} />
                <Table.Summary.Cell index={7} />
                <Table.Summary.Cell index={8} />
              </Table.Summary.Row>
            </Table.Summary>
          )}
        />
        <TablePagination
          page={page}
          paginationData={paginationData}
          changePage={changePage}
          changeSize={changeSize}
        />
      </div>
      {showDetail && (
        <MerchantVatOutDetail
          open={showDetail}
          close={() => setShowDetail(null)}
        />
      )}
    </div>
  );
};

export default MerchantVatOut;
